import ReactToPrint from 'react-to-print';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import asArray from 'utils/arrays/asArray.util';

import CN from './TipsCard.module.scss';

export const TipsCard = ({ tips, printTargetRef, url, className }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isFromMobile = useIsFromMobileApp();

  return (
    <div
      className={cn({
        'comment-content': true,
        [CN.component]: true,
        [className]: className,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div className={CN.textLayout}>
        {asArray(tips).map(({ title, description }, index) => (
          <div key={index} className={CN.tip}>
            <span className={CN.icon} aria-hidden="true">
              {S.lamp}
            </span>
            <div>
              <span className={CN.title}>
                {title ?? t('businessReports.tipsCard.proTip')}
                {S.colon}
              </span>
              {S.space}
              <span className={CN.description}>{description}</span>
            </div>
          </div>
        ))}
      </div>

      {!isFromMobile && (url || printTargetRef) && (
        <div className={CN.buttonsLayout}>
          {url && (
            <ExternalLink link={url} variant="link">
              <span className={CN.link}>{t('businessReports.tipsCard.needHelp')}</span>
            </ExternalLink>
          )}
          {printTargetRef && (
            <ReactToPrint
              trigger={() => (
                <Button variant="primaryForce" width="small" className={CN.pdfButton}>
                  {t('businessReports.tipsCard.printPDFButton')}
                </Button>
              )}
              content={printTargetRef}
            />
          )}
        </div>
      )}
    </div>
  );
};
